import React from 'react'
import { Link, LinkProps } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'

interface ButtonLinkProps extends Omit<LinkProps, 'to' | 'className' | 'children'> {
  to: string
  children: React.ReactNode
  className?: string
}

const ButtonLink: React.FC<ButtonLinkProps> = ({
  to,
  children,
  className: customClassName = '',
  ...rest
}) => {
  const baseStyles = 'tw-text-center tw-font-semibold tw-rounded-md tw-shadow-sm tw-transition-colors tw-bg-green hover:tw-bg-opacity-90 tw-text-white tw-px-4 tw-py-2 tw-text-sm lg:tw-px-5 lg:tw-py-2.5 lg:tw-text-base'

  const combinedClassName = twMerge(baseStyles, customClassName)

  return (
    <Link
      to={to}
      className={combinedClassName}
      {...rest}
    >
      {children}
    </Link>
  )
}

export default ButtonLink
